module.exports = __webpack_public_path__ + "img/icon-facebook.6c2650d8.svg";